module.exports = __webpack_public_path__ + "static/media/month_03.cb23aef2.png";